export default "__VITE_ASSET__fa9ede0e__"